import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { deviceService, licenseService, announcementService } from '../../_services'
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Button } from 'react-bootstrap'
import styles from './details.module.css';
import moment from 'moment'

function DeviceDetails() {

	const {uuid} = useParams()
	const [licenses, setLicenses] = useState([])
	const [device, setDevice] = useState(null)
	const [announcements, setAnnouncements] = useState([])
	const {t} = useTranslation('common')

	useEffect(() => {
		licenseService.simpleList().then(licenses => {
			setLicenses(licenses)

            deviceService.get(uuid).then(device => {
				setDevice(device)
		    })

		    announcementService.getAnnouncementsForDevice(uuid).then(announcements => {
				setAnnouncements(announcements)
		    })
        })
	}, [])

	const formatDate = (date) => {
		if (date) {
			return moment(date).format('YYYY-MM-DD HH:mm:ss')
		}
		return '-'
	}

	const formatBoolean = (cell) => {
		return cell ? t('crudtable.yes') : t('crudtable.no')
	}

	const formatSize = (cell, row) => {
	    if (cell) {
			var i = Math.floor( Math.log(cell) / Math.log(1000) );
	        return ( cell / Math.pow(1000, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
	    }
	    return 0
    }

    const formatPushId = (pushId) => {
        return pushId.substring(0, 12) + '...' + pushId.substring(pushId.length - 12, pushId.length)
    }

    const testPush = (e) => {
        deviceService.testPush(uuid).then(result => {
			console.log(result)
	    })
    }

	return (
		<Container className={styles.deviceDetails}>
			{ licenses.length > 0 && device &&
				<Row>
					<Col md="12">
						<h2>
							{device.deviceId}
						</h2>
					</Col>
					<Col>
						<div>
		                    <label>
		                        {t('device.columns.id')}
		                    </label>
		                    { device.id || '-' }
	                    </div>
						<div>
		                    <label>
		                        {t('device.columns.datecreated')}
		                    </label>
		                    { device.dateCreated ? formatDate(device.dateCreated) : '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.lastupdated')}
		                    </label>
		                    { device.lastUpdated ? formatDate(device.lastUpdated) : '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.username')}
		                    </label>
		                    { device.username || '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.osversion')}
		                    </label>
		                    { device.osVersion || '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.phonemodel')}
		                    </label>
		                    { device.phoneModel || '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.appversion')}
		                    </label>
		                    { device.appVersion || '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.deletephotosafterupload')}
		                    </label>
		                    {formatBoolean(device.deletePhotosAfterUpload)}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.backuptolibrary')}
		                    </label>
		                    {formatBoolean(device.backupToLibrary)}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.uploadonwifionly')}
		                    </label>
		                    {formatBoolean(device.uploadOnWifiOnly)}
	                    </div>
                    </Col>
                    <Col md={{ span: 6, offset: 0 }}>
	                    <div>
		                    <label>
		                        {t('device.columns.darkmode')}
		                    </label>
		                    { device.darkMode != null ? formatBoolean(device.darkMode) : '-'}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.availablestoragespace')}
		                    </label>
		                    { device.availableStorageSpace != null ? formatSize(device.availableStorageSpace) : '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.currentlicense')}
		                    </label>
		                    { licenses.map(license => {
		                        if (license.id == device.currentLicenseId) {
		                            return <div key={license.id}>
			                            {license.name ? license.name + ' (' + license.licenseCode + ')' : license.licenseCode}
			                        </div>
		                        }
		                        return <div key={license.id}></div>
		                    })}
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.licenses')}
		                    </label>
		                    <ul>
			                    { device.licenses.map(licenseId => {
			                        var license = licenses.find(license => license.id === licenseId)
			                        return <li key={licenseId}>
			                            {license.name ? license.name + ' (' + license.licenseCode + ')' : license.licenseCode}
			                        </li>
			                    })}
		                    </ul>
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.pushid')}
		                    </label>
		                    { device.pushId &&
		                        <>
			                        <span title={device.pushId}>
			                            {formatPushId(device.pushId)}
			                        </span>
			                        <br/>
			                        <Button variant="outline-primary" onClick={testPush}>
							            {t('device.testpush')}
							        </Button>
		                        </>
		                    }
		                    { !device.pushId &&
		                        '-'
		                    }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.locale')}
		                    </label>
		                    { device.locale || '-' }
	                    </div>
	                    <div>
		                    <label>
		                        {t('device.columns.email')}
		                    </label>
		                    { device.email || '-' }
	                    </div>
					</Col>
					<Col md="12" style={{ marginTop: 20 }}>
						<table className="table">
		                    <thead>
		                        <tr>
		                            <th>
										Id
		                            </th>
		                            <th>
										{t('announcement.columns.datecreated')}
		                            </th>
		                            <th>
										{t('announcementdevice.columns.dateread')}
		                            </th>
		                            <th>
										{t('announcementdevice.columns.datedismissed')}
		                            </th>
		                            <th>
										{t('announcementdevice.columns.datecreated')}
		                            </th>
		                            <th>
										{t('announcementdevice.columns.lastupdated')}
		                            </th>
		                        </tr>
		                    </thead>
		                    <tbody>
		                    { announcements.map(announcement => {
		                        var announcementDevice = announcement.devices.find(device => device.id == uuid)
		                        return <tr key={announcementDevice.id}>
		                            <td>
		                                { announcement.id }
		                            </td>
		                            <td>
		                                <a href={"/announcement/" + announcement.id} target="_blank">
		                                    { formatDate(announcement.dateCreated) }
		                                </a>
		                            </td>
		                            <td>
		                                { formatDate(announcementDevice.dateRead) }
		                            </td>
		                            <td>
		                                { formatDate(announcementDevice.dateDismissed) }
		                            </td>
		                            <td>
		                                { formatDate(announcementDevice.dateCreated) }
		                            </td>
		                            <td>
		                                { formatDate(announcementDevice.lastUpdated) }
		                            </td>
		                        </tr>
		                    })}
		                    </tbody>
		                </table>
					</Col>
				</Row>
			}
		</Container>
	)
}

export default DeviceDetails;